import { LoyaltyOfferType } from "../../../utils/loyaltyTypes";
import type {
  OrderCartV2Line,
  OrderCartV2OfferSelection,
  OrderCartV2Output,
} from "./OrderCartV2Types";

type LoyaltyApplyRedirect = {
  itemId?: number;
  subItemId?: number;
  loyaltyItemFromListOffer?: LoyaltyOfferType;
};

type LoyaltyRedemptionSession = {
  offer: LoyaltyOfferType;
  offerApplicationId: string;
  /** Lines + quantities sent as EXPLICIT selections on next calculate */
  pendingSelections?: OrderCartV2OfferSelection[];
  /** lineIds pushed during this redemption (removed on removeLoyaltyOffer / INVALID) */
  addedLineIds?: string[];
};

type LoyaltyPayWithPointsSession = {
  requestedPoints: number;
  useMaxPoints?: boolean;
};

export type LoyaltyCartState = {
  /** Request/response cart lines — V2 path only */
  lines: OrderCartV2Line[];
  /** Last successful calculateOrderCartV2 response */
  result?: OrderCartV2Output;
  payWithPoints?: LoyaltyPayWithPointsSession;
  /** From getCustomerLoyaltyOffers */
  customerOffers?: LoyaltyOfferType[];
  /** Active redeem session; undefined when no offer selected */
  redemption?: LoyaltyRedemptionSession;
  /** In-flight UI: item-from-list popup, item-page addon redirect */
  applyFlow?: {
    selectedOfferId?: string;
    redirect?: LoyaltyApplyRedirect;
  };
  /**
   * Offer failure surfaced by the create-receipt response (V2 flow). Drives the
   * OfferError popup using the new loyaltyV2 offer format instead of the legacy
   * `cartAndLoyaltyReducer.offerErrorReason`.
   */
  offerError?: {
    code?: string;
    message?: string;
  };
};

export const initialLoyaltyCartState: LoyaltyCartState = {
  lines: [],
};
